var ContextActionType;
(function (ContextActionType) {
    ContextActionType["ACTION"] = "action";
    ContextActionType["SEPARATOR"] = "separator";
})(ContextActionType || (ContextActionType = {}));
export { ContextActionType, };
//# sourceMappingURL=context-action.js.map